import React, { useState, useRef, useEffect } from "react";
import Form from 'react-bootstrap/Form'
import Switch from "react-switch"

import { ToastContainer, toast } from "react-toastify";
import Table from "./Table.js";
import DatePicker from 'react-datepicker'
import { DateTime } from 'luxon'
import "react-datepicker/dist/react-datepicker.css";
import './admin.css';
import { useAppStore, useBranchStore, useSectionStore } from "../../stores"
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import EditModalAdmin from "./EditModalAdmin";
import { useImmer } from 'use-immer';
import { map } from "jquery";
import filters from "react-bootstrap-table-next/lib/src/filters";
import YearCollapse from "./YearCollapse";
import DeleteModal from "./DeleteModal";
import { FaCalendarAlt } from "react-icons/fa";
import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";
import SelectBranch from "./SelectBranch.js";
import { handleXhrError } from "../../utils/index.js";
const MySwal = withReactContent(Swal);
const toastOptions = {
  position: "top-center",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
};
const TOMORROW = DateTime.now().plus({ days: 1 }).toJSDate();
// const AFTER_YEAR = DateTime.now().plus({ days: 1, years: 1 }).toJSDate();
const AFTER_YEAR = DateTime.now().plus({ days: 1, months: 18 }).toJSDate();
const BatchOptions = ({ date, currentBatch, year, newBatch }) => {
  const presentYear = DateTime.utc().year;
  const presentBatch = newBatch || currentBatch;
  console.log("Batch", presentBatch);
  const diff = presentYear - year - presentBatch + 1;
  if (presentBatch < presentYear) {
    return (
      <>
        <option key={year + "0"} value={presentBatch} selected={true}>{presentBatch}</option>
        <option key={year + "1"} value={presentYear - year + diff}>{presentYear - year + diff}</option>
      </>
    )
  }
  // not possible
  else if (presentBatch > presentYear) {
    return (
      <>
        <option key={year + "0"} value={presentBatch} selected={true}>{presentBatch}</option>
        <option key={year + "1"} value={presentYear - year}>{presentYear - year}</option>
      </>
    )
  }
  else {
    return (
      <>
        <option key={year + "0"} value={presentBatch} selected={true}>{presentBatch}</option>
        <option key={year + "1"} value={presentYear - year + diff}>{presentYear - year}</option>
      </>
    )
  }
}

const Admin = () => {
  const [openModal, setOpenModal] = useImmer({ open: false, isNew: true });
  const [dob, setDob] = useImmer({ eoa: [] });
  const [eoaModal, setEoaModal] = useState(false);
  const branchId = useBranchStore(state => state.branchId);
  const setBranchId = useBranchStore(state => state.setBranchId);

  const loading = useAppStore(state => state.loading);
  const showLoading = useAppStore(state => state.showLoading);
  const hideLoading = useAppStore(state => state.hideLoading);

  const addAllBranches = useBranchStore(state => state.addAllBranches);
  const branches = useBranchStore(state => state.branches);
  const currentBranch = useBranchStore(state => state.currentBranch);
  const setCurrentBranch = useBranchStore(state => state.seCurrentBranch);

  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const addSection = useSectionStore((state) => state.addSection);
  const sections = useSectionStore((state) => state.sections);
  const sectionRef = useRef();
  const yearRef = useRef();
  const defaultYear = currentBranch.years[0];
  const deleteRef = useRef({});
  const semesterRef = useRef(1);
  const [editableRow, setEditableRow] = useState({ name: "John Doe", email: 'johndoe@example.com', firstName: "John" });
  const addtempRow = useSectionStore(state => state.addtempRow);
  const updateEoa = useBranchStore(state => state.updateEoas);
  const [sem, setSem] = useState(1);
  const branch = useSectionStore((state) => state.branch);
  // const eoa=branch.eoa;
  const duration = branch.degree ? branch.degree.duration : 0;
  useEffect(() => {
    let eoas = [];
    if (currentBranch.eoa) {
      // converting to local time
      currentBranch.eoa.forEach(ele => {
        const date = DateTime.fromISO(ele.date).toLocal();
        console.log(date < TOMORROW);
        if (date < TOMORROW) {
          date.plus({ years: 1 });
        }
        else {
          date.minus({ years: 1 });
        }
        eoas.push({ ...ele, date: date });
      });
      console.log("EOA:", currentBranch.eoa);
      setDob((draft) => void (draft.eoa = (currentBranch.eoa ? eoas : [])));
    }
  }, [currentBranch.eoa, eoaModal])

  console.log(dob);

  const postsection = (data) => {
    console.log(data);
    window.$.ajax({
      type: "post",
      url: "/api/admin/sections",
      xhrFields: {
        withCredentials: true,
      },
      data: {
        name: data.name,
        firstName: data.firstName,
        lastName: " ",
        year: data.year,
        sem: data.sem,
        email: data.email,
        branch: branchId
      },
      dataType: "json",
      success: (response, textStatus, request) => {
        console.log(response);
        addSection(response.section);
        console.log("success")
        MySwal.fire("section successfully added");
        sectionRef.current.value = "";
        yearRef.current.value = defaultYear;
        semesterRef.current.value = "1";
        addtempRow({});
        setOpenModal((draft) => {
          draft.open = false;
        });

      },
      statusCode: {

        404: function () {
          // e.target.disabled = false;
          toast.error("page not found", toastOptions);
        },
        400: function (res) {
          // e.target.disabled = false;
          if (!res.responseJSON) {
            toast.error("Something went wrong...", toastOptions);
            return;
          }

          toast.error(res.responseJSON.message, toastOptions);
          return;
        },
      },
      headers: {
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "",
      },
      error: function (res, textStatus, err) {
        handleXhrError(res, textStatus, err, () => {
          // e.target.disabled = false;
        })
      },
    });
  }
  const updateSection = (data) => {
    console.log(data);
    window.$.ajax({
      type: "put",
      url: "/api/admin/sections/" + data._id,
      xhrFields: {
        withCredentials: true,
      },
      data: {
        name: data.name,
        firstName: data.firstName,
        lastName: " ",
        year: data.year,
        sem: data.sem,
        email: data.email
      },
      dataType: "json",
      success: (response, textStatus, request) => {
        console.log(response);
        addSection(response.section);
        console.log("success")
        MySwal.fire("section successfully updated");
        sectionRef.current.value = "";
        yearRef.current.value = "1";
        semesterRef.current.value = "1"
        addtempRow({});
        setOpenModal((draft) => {
          draft.open = false;
        });

      },
      statusCode: {

        404: function () {
          // e.target.disabled = false;
          toast.error("page not found", toastOptions);
        },
        400: function (res) {
          // e.target.disabled = false;
          if (!res.responseJSON) {
            toast.error("Something went wrong...", toastOptions);
            return;
          }

          toast.error(res.responseJSON.message, toastOptions);
          return;
        },
      },
      headers: {
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "",
      },
      error: function (res, textStatus, err) {
        handleXhrError(res, textStatus, err, () => {
          // e.target.disabled = false;
        })
      },
    });
  }

  const addSectionHandle = (e) => {
    if (!sectionRef.current.value || sectionRef.current.value.length < 1) {
      toast.error("Section required", toastOptions);
      return;
    }
    e.preventDefault();
    setTimeout(() => {
      setOpenModal((draft) => {
        draft.open = true;
        draft.isNew = true;
      });
    }, 100);
    addtempRow({
      name: sectionRef.current.value,
      year: yearRef.current.value,
      sem: semesterRef.current.value
    });
  }
  const addSelectClass = () => {
    window.$('.react-datepicker__month-select').addClass('form-select');
    window.$('.react-datepicker__year-select').addClass('form-select');
  }
  const handleEoa = async () => {
    let eoaObj = {};
    dob.eoa.forEach(eoa => {
      eoaObj[eoa.year + ""] = eoa;
    });
    const r = await fetch("/api/admin/eoas/" + currentBranch._id, {
      body: JSON.stringify(
        {
          "eoas": eoaObj
        }
      ),
      method: "PUT",
      headers: {
        'Content-Type': 'application/json'
      }
    })
    let res = await r.json();
    if (r.status == 200) {
      console.log(res);
      console.log("success");
      updateEoa(dob.eoa);
      return toast.success("successfully updated,dashboard will update at 12pm", toastOptions);
    }
    else {
      return toast.error(res.message, toastOptions);
    }
  }
  const Dob = ({ dob, setDob, index }) => {
    // const [startDate, setStartDate] = useState(new Date());
    console.log(DateTime.now().plus({ days: 1 }).toJSDate());
    return (
      <div className="p-1">
        {/* <label for="dob" class="form-label">DOB (DD-MM-YYYY)</label> */}
        <DatePicker
          selected={Date.parse(dob.eoa[index].date)}
          peekNextMonth
          minDate={TOMORROW}
          maxDate={AFTER_YEAR}
          filterDate={date => {
            // allow non leap year
            if (!DateTime.fromJSDate(date).isInLeapYear) {
              return true;
            }
            if (date.getMonth() === 1 && date.getDate() === 29) {
              return false;
            }
            return true;
          }}
          autoComplete="off"
          showMonthDropdown
          showYearDropdown
          dropdownMode="select"
          onCalendarOpen={() => addSelectClass()}
          placeholderText="DD-MM-YYYY"
          dateFormat="dd-MM-yyyy"
          onKeyDown={(e) => e.preventDefault()}
          className="dateInput col-12 form-control"
          id="dob"
          onChange={(date) => {
            if (date) {
              console.log(date);
              setDob(draft => void (draft.eoa[index].date = date.toISOString()))
            } else {
              // setDob(null);
            }
          }} />
      </div>
    );
  }
  if (loading) {
    return showLoading();
  }
  return (
    <>
      <SelectBranch />
      <EditModalAdmin show={openModal.open} onClose={() => setOpenModal(draft => void (draft.open = false))} onSend={postsection} onUpdate={updateSection} isNew={openModal.isNew} />
      <DeleteModal open={openDeleteModal} ref={deleteRef} onClose={() => setOpenDeleteModal(false)} mode="section" />
      <form className="p-4 m-0" style={{ width: "99%" }}>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <h1 className="mainHeading">{branch.name} dept.</h1>
          <Popup
            className="subModal"
            position="top center"
            onOpen={() => setEoaModal(true)}
            onClose={() => setEoaModal(false)}
            trigger={
              <button className="eoa" type="button"><FaCalendarAlt /> End of Academic</button>
            }
            modal
          >
            {(close) => (
              <div>
                <button className="closeColorBtn" onClick={close}>
                  &times;
                </button>

                <h5 className="p-1" style={{ color: "white" }}> Set end of academic year </h5>
                <div className="content">
                  <table className="table table-dark table-striped">
                    <thead >
                      <tr style={{ color: "white" }}>
                        <th className="col-1 col-md-4 ">Year</th>
                        <th className="col-1 col-md-4 pe-0 ps-0">Batch</th>
                        <th className="col-10 col-md-4">Endson</th>
                      </tr>
                    </thead>
                    <tbody>

                      {dob.eoa.map((eo, index) => {
                        if (currentBranch.years.includes(eo.year)) {
                          return (
                            <tr>
                              <td ><h6 style={{ color: "white" }}>{eo.year}</h6></td>
                              <td className="pe-0 ps-0">
                                <select value={() => {
                                  const eoaObj = dob.eoa.find(a => a.year.toString() === eo.year.toString());
                                  return (eoaObj.newBatch || eoaObj.currentBatch);
                                }} name="cur_batch" onChange={(e) => setDob(draft => {
                                  console.log("Selected::::::", e.target.value);
                                  draft.eoa.find(a => a.year.toString() === eo.year.toString()).newBatch = parseInt(e.target.value);
                                })} className="form-select col-4 ms-1 branchSelect" placeholder="Select Batch" style={{ border: "none" }}>
                                  <BatchOptions {...eo} />
                                </select>
                              </td>
                              <td className="p-0"><Dob dob={dob} setDob={setDob} index={index} /></td>
                            </tr>
                          )
                        }
                      })}

                    </tbody>
                  </table>
                  <div
                    className="actions"
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <button className="eoa ps-4 pe-4" onClick={(e) => { handleEoa(e).then(() => close(e)) }}>Save</button>
                  </div>
                </div>
              </div>
            )}
          </Popup>

        </div>
        <h5 className="mainHeading subheading">Add sections in each year</h5>
        <h3 className="mainHeading mt-4">Add sections</h3>
        <div className="row" id="addSection">
          <div className="form-group col-md-4">
            <label for="Degree" className="addSlabel">Section</label>
            <input
              type="text"
              required
              ref={sectionRef}
              className="form-control addS"
              placeholder="Enter section name"
            />
          </div>

          <div className="form-group col-md-4">
            <label for="years" className="addSlabel">Year</label>
            <Form.Select className="addS" ref={yearRef}>
              {
                currentBranch.years.map((d, index) => <option key={index} value={d}>{d}</option>)
              }
              {/* {
                Array.from({ length: duration }).map((d, index) => <option value={index + 1}>{index + 1}</option>)
              } */}
            </Form.Select>
          </div>

          <div className="form-group col-md-4">
            <label for="semesters" className="addSlabel">Semister</label>
            <Form.Select className="addS" ref={semesterRef}>
              <option value={1}>1</option>
              <option value={2}>2</option>
            </Form.Select>
          </div>
        </div>
        <div style={{ display: "flex", width: "100%", justifyContent: "center" }}>
          <button className="addSectionbtn col-md-4 mt-4 mb-3" onClick={addSectionHandle}>Add Section</button>
        </div>
        <h3 className="mainHeading m-0 ">Sections you've added</h3>
        <div className="ms-auto me-auto col-3 d-flex justify-content-evenly">
          <span className="fs-4 fw-bolder pe-1" style={{ whiteSpace: "nowrap" }}>Show semester </span>
          <span className="mt-auto mb-auto">
            <Switch checkedIcon={<h4 style={{ color: "white", fontWeight: "700", paddingLeft: "0.6rem" }}>1</h4>} uncheckedIcon={<h4 style={{ color: "white", fontWeight: "700", paddingLeft: "0.4rem" }}>2</h4>} checked={sem == 1} onChange={() => setSem(3 - sem)} />
          </span>
        </div>
      </form>
      <YearCollapse setOpenModal={setOpenModal} setOpenDeleteModal={setOpenDeleteModal} deleteRef={deleteRef} sem={sem} branchId={branchId} />
      <div className="row m-0 p-0" style={{ width: "100%", overflowX: "auto" }}>
      </div>

    </>
  );
};

export default Admin;